/**
 * @generated SignedSource<<3f88766872f1fc5be4e533ae657a6ea3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteCustomFieldDropdownOptionConfirmationModal_viewer$data = {
  readonly customFieldDefinition: {
    readonly options?: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
      readonly isUsed: boolean;
    }>;
  } | null;
  readonly " $fragmentType": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer";
};
export type DeleteCustomFieldDropdownOptionConfirmationModal_viewer$key = {
  readonly " $data"?: DeleteCustomFieldDropdownOptionConfirmationModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteCustomFieldDropdownOptionConfirmationModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "customFieldId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "customFieldId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "customFieldDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomFieldDropdownOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUsed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "DropdownCustomField",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eef03a8d18e17dc32f062b0afcdca2fe";

export default node;
